module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Legendary Locals of Toledo")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head1",
    attrs: {
      "id": "Ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("I would first like to thank my colleagues in the Ward M. Canaday Center for Special Collections for their assistance and helping to keep the Canaday Center running smoothly during the time I was at work on this project: Arjun Sabharwal, Tamara Jones, Sara Mouch, and Lauren White. It is wonderful to work with such talented hard-working people who are dedicated to collecting, preserving, and making available collections that help to document the history of our city. The collections of the Canaday Center are rich in their depth and breadth, and there is no better proof of this statement than the fact that most of the images in this book are from the center’s collections.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I would also like to thank those at other archival repositories and organizations who provided images for the book: Donna Christen, local history and genealogy department, Toledo-Lucas County Public Library; Karen Mason and Janet Weaver, Iowa Woman’s Archives; Phillip L. Kaplan and the "), _c('i', [_vm._v("Toledo Blade")]), _vm._v("; Dan Saevig from his personal collection; and Mary Mennel, 577 Foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Erin Vosgien, my editor at Arcadia Publishing, kept me on track, and I appreciate her support and help.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Lastly, I would like to thank my husband, Bill Little, for his support and assistance in everything.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unless otherwise noted, all images appear courtesy of the Ward M. Canaday Center for Special Collections, the University of Toledo.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0